
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
@Component({})
export default class ProjectCostPerformance extends Vue {
    @Prop({ default: () => [] })
    rows!: Array<any>;
    @Prop({ default: () => [] })
    disabled!: boolean;
    
    forceReload = 0;

    updateLineSum(itemId: any, projectId: any, actualBudgetCost: number, budgetTemplateId: number, lineSplit: any, lineItem: any, sectionName: any) {
      this.$emit('lineValueChanged', {itemId, projectId, actualBudgetCost, budgetTemplateId, lineSplit, lineItem, sectionName})
    }

    planCalculateTotal(rows: any[]) {
      return rows.reduce((acc, row) => acc + (row.plan || 0), 0);
    }
    actualCalculateTotal(rows: any[]) {
      return rows.reduce((acc, row) => acc + (row.actualBudgetCost || 0), 0);
    }
    actualDailyCalculateTotal(rows: any[]) {
      return rows.reduce((acc, row) => acc + (row.actualDailyBudgetCost || 0), 0);
    }
    varianceCalculateTotal(rows: any[]) {
      return rows.reduce((acc, row) => acc + (row.variance || 0), 0);
    }

    mounted() {
      this.forceReload += 1;
    }
}
